// extracted by mini-css-extract-plugin
module.exports = {"Container":"Details_Container__WjNS6","BlackContainer":"Details_BlackContainer__2O8xa"};